import { render, staticRenderFns } from "./IlamBilgileriMahkemePicker.vue?vue&type=template&id=14209c70&scoped=true"
import script from "./IlamBilgileriMahkemePicker.vue?vue&type=script&lang=ts"
export * from "./IlamBilgileriMahkemePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14209c70",
  null
  
)

export default component.exports